/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// MAIN
import apClosureReportsReducerParts from './main/reducerParts';
import { initialState as apClosureReportsInitialState } from './main/initialState';

// FILTERS
import filtersRecuerParts from './filters/reducerParts';
import { initialState as filtersInitialState } from './filters/initialState';

const initialState = {
	...apClosureReportsInitialState,
	...filtersInitialState,
};

const reducerParts = {
	...apClosureReportsReducerParts,
	...filtersRecuerParts,
};

export default handleActions(reducerParts, initialState);
